export const createFilterConfig = () => {
  return [
    {
      name: "name",
      fieldType: "text",
      placeholder: "Name",
      filterType: 'search'
    },
    {
      name: "promptType",
      fieldType: "text",
      placeholder: "Prompt type",
      filterType: 'search'
    },
  ];
};
